import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZAlertCountDetails = z.object({
  assetId: z.string().optional(),
  parameterName: z.string().nullable(),
  alarmRaisedAt: z.string(),
  referenceId: z.string().optional(),
  parentAssetId: z.string().optional()
})

export const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: z.array(ZAlertCountDetails)
})

export type alertCountDataAssetDashboard = z.infer<typeof ZApiResponse>
export type alertCountDataDetails = z.infer<typeof ZAlertCountDetails>

export async function getAssetAlertCountByAssetId (
  siteId: string,
  assetId: string,
  severity: string,
  onSuccess: (AssetAlertCountData: any, httpStatus: number) => void,
  onFailure: (errorMessage: any, httpStatus: number) => void
): Promise<void> {
  const url = `/alarm-service/api/v1/udp/tiq/assets/alerts/activeAlerts/${siteId}/${assetId}?severity=${severity}`
  interceptedAxios
    .get(url, { timeout: 10000 })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
